import React, { FunctionComponent } from 'react';
import { useLocation } from 'react-router-dom';
import { Loader } from 'rs-emd-ui-atoms';
import { useCampaignPageQuery } from '../../../generated/graphql';
import { CampaignPage } from '../../../rs-emd-ui-modules/src/components/campaign-pages';
import { RedirectWithStatus } from '../../../rs-emd-ui-modules/src/helpers/redirect-with-status.component';
import { IContextInfo } from '../../../rs-emd-ui-modules/src/models/master/context-info.model';
import { useSSRContext } from '../../app/ssr-context';

type CampaignPageWrapperProps = {
  contextInfo: IContextInfo;
};

export const CampaignPageWrapper: FunctionComponent<CampaignPageWrapperProps> = ({ contextInfo }) => {
  const location = useLocation();
  const ssrContext = useSSRContext();

  //#1j4qtdp
  const brandPagePrefix = '/ourbrands/';
  const brandContentUrlPrefix = '/content/brand-page/';

  let url = location.pathname;
  if (url.startsWith(brandPagePrefix)) {
    url = url.replace(brandPagePrefix, brandContentUrlPrefix);
  }

  // retrieve host and user-agent from SSR context if available
  const host = ssrContext?.headers?.host ?? (typeof window !== 'undefined' ? window.location.hostname : '');
  const userAgent = ssrContext?.headers?.['user-agent'] ?? '';

  let isCampaignPreview = host.includes('localhost') || host.includes('uat') || host.includes('rs-emd-dev-aws.rsdelivers.com');

  const isPreviewQueryString = new URLSearchParams(location.search).get('isPreview');
  if (isPreviewQueryString != null) {
    try {
      isCampaignPreview = Boolean(JSON.parse(isPreviewQueryString.toLowerCase()));
    } catch {
      // ignore parsing errors
    }
  }

  // retrieve logged-in homepage CMS preview arguments
  const loggedInHomepagePreviewPageId = new URLSearchParams(location.search).get('loggedInHomepagePreviewPageId');
  const userIndustryId = new URLSearchParams(location.search).get('userIndustryId');

  const { loading, error, data } = useCampaignPageQuery({
    variables: {
      url: encodeURIComponent(url),
      isPreview: isCampaignPreview,
      loggedInHomepagePreviewId: loggedInHomepagePreviewPageId ? Number(loggedInHomepagePreviewPageId) : null,
      userIndustryId: userIndustryId ? Number(userIndustryId) : null,
    },
    ssr: true,
  });

  if (loading) return <Loader />;
  if (userAgent === 'ELB-HealthChecker/2.0') {
    // return 200 so that the health check doesn't fail
    return <RedirectWithStatus to={process.env.REACT_APP_ERROR_404_ENDPOINT} statusCode={200} />;
  }
  if (error || !data) {
    return <RedirectWithStatus to={process.env.REACT_APP_ERROR_ENDPOINT} statusCode={500} />;
  }
  if (!data.campaignPage.layouts || data.campaignPage.layouts.length === 0) {
    return <RedirectWithStatus to={process.env.REACT_APP_ERROR_404_ENDPOINT} statusCode={404} />;
  }
  return <CampaignPage data={data.campaignPage} contextInfo={contextInfo} />;
};

export default CampaignPageWrapper;
